import { Component } from 'vue-property-decorator'

import { TranslatedString, getTranslatedString } from '@skinsoft/types'
import { hasTranslationOrFallback } from '@skinsoft/utils';

import { ReactiveVue } from '@skinsoft/reactive-vue';

declare const config
const FALLBACK_LOCALE = config.fallback_locale

@Component({
    props: {
        tag: {
            required: false,
            type: String,
        },
        // NEED TO FIND BETTER NAMES FOR value and values
        value: [Number, String, Object],
        values: {
            required: false,
            type: [Array, Object],
        },
        dataCy: {
            required: false,
            type: String
        }
    },
})
export class LocalizedString extends ReactiveVue {
    public tag: string;
    // NEED TO FIND BETTER NAMES FOR value and values
    public value: string | TranslatedString;
    public values: any[] | Record<string, any>;
    public dataCy: String

    public render(createElement) {
        let message = "";
        // Value is a translation key, looking in locales.ts
        if (typeof this.value === "string") {
            const isTranslationKey = hasTranslationOrFallback(this.$i18n, this.value)

            message = isTranslationKey ? this.$t(this.value, this.values) as string : this.value
        }
        // Value is a translated string, unmarshalling it with current locale
        else {
            message = getTranslatedString(
                this.value, 
                this.getAppLocale(), 
                FALLBACK_LOCALE
            )
        }

        return createElement(
            this.tag || 'span', 
            {
                on: {
                    click: (event) => this.$emit('click', event)
                },
                attrs: {
                    'data-cy': this.dataCy
                },
            }, 
            message
        )
    }
}
